import React from "react";
import Navbar from "@/components/Navbar";
import { Link } from "react-router-dom";
import TreeMark from "@/components/TreeMark";
import PrivacyNotice from "@/components/PrivacyNotice";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAF9F6]">
      <Navbar />
      <main className="flex-1 page-fade">{children}</main>
      <footer className="border-t border-[#EAE6E1] bg-[#FAF9F6] mt-16">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <TreeMark size={44} tone="dark" />
              <div className="font-serif text-xl text-[#2D332D] leading-tight">At The End of The Day</div>
            </div>
            <p className="text-sm text-[#576056] mt-3 leading-relaxed max-w-xs">
              A gentle companion for end-of-life admin — for those preparing, and those bereaved.
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.15em] text-[#8A9488] mb-3">Explore</div>
            <div className="space-y-2">
              <Link to="/guide/bereaved" className="block text-sm text-[#2D332D] hover:text-[#6B7F62]">If you've been bereaved</Link>
              <Link to="/guide/prepare" className="block text-sm text-[#2D332D] hover:text-[#6B7F62]">Prepare for your family</Link>
              <Link to="/chat" className="block text-sm text-[#2D332D] hover:text-[#6B7F62]">Ask a question</Link>
              <Link to="/security" data-testid="footer-security-link" className="block text-sm text-[#2D332D] hover:text-[#6B7F62]">Trust &amp; security</Link>
              <Link to="/privacy" data-testid="footer-privacy-link" className="block text-sm text-[#2D332D] hover:text-[#6B7F62]">Privacy notice</Link>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.15em] text-[#8A9488] mb-3">Support in the UK</div>
            <div className="space-y-1.5 text-sm text-[#576056]">
              <div>Cruse Bereavement — 0808 808 1677</div>
              <div>Samaritans — 116 123</div>
              <div>Citizens Advice — 0800 144 8848</div>
            </div>
          </div>
        </div>
        <div className="border-t border-[#EAE6E1]">
          <div className="max-w-6xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-[#8A9488]">
            <div className="space-y-1 max-w-3xl leading-relaxed">
              <div>© {new Date().getFullYear()} At The End of The Day. Guidance, not legal advice. Created by Lauren Jordan, All Day VA. All rights reserved.</div>
              <div className="text-[#A8ADA5]">
                This website and all content (including guides, downloads, and resources) are protected by copyright and may not be copied, shared, or reproduced without prior written permission.
              </div>
            </div>
            <div className="flex flex-col md:items-end gap-1 flex-shrink-0">
              <PrivacyNotice variant="footer" />
              <span>Made with care · UK</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
